import React from 'react';

import ContentWell from '@components/libraryV2/ContentWell';
import Heading from '@components/libraryV2/Heading';
import TwoColumnImage from '@components/libraryV2/TwoColumnImage';

import * as styles from './styles.module.scss';

export const ContentImageRow = ({
  backgroundSize,
  banner,
  children,
  className,
  columnClassName,
  fixed,
  id,
  image,
  reverse,
  reverseBackground,
  secondary,
  size,
  tighten,
  title,
  titleSize = 'h3',
  titleTag,
  withBackground,
}) => (
  <ContentWell
    backgroundSize={backgroundSize}
    banner={banner}
    className={className}
    size={size}
    secondary={secondary}
    tighten={tighten}
    reverseBackground={reverseBackground}
    withBackground={withBackground}
  >
    <TwoColumnImage
      className={columnClassName}
      left={
        <div className={styles.content}>
          {title ? (
            <Heading id={id} size={titleSize} tagType={titleTag}>
              {title}
            </Heading>
          ) : null}
          <div className={styles.children}>{children}</div>
        </div>
      }
      right={image}
      fixed={fixed}
      reverse={reverse}
    />
  </ContentWell>
);

export default ContentImageRow;
